import styled from 'styled-components';

const SvgButton = styled.button `
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;

  background: transparent;
  line-height: normal;
  cursor: pointer;
  -webkit-appearance: none;

  &:focus {
    outline: none;

    svg {
      stroke-width: 1;
      stroke: currentColor;
    }
  }
`;

export { SvgButton };
//# sourceMappingURL=SvgButton.js.map
